import { gql } from "@apollo/client";
import {
  RESULT_FILTER_METADATA,
  DISCIPLINE_FIELDS,
  BADGES_FIELDS,
  SKILLS_FIELDS,
  LOCATION_FIELDS,
  RATE_FIELDS,
  PROFILE_ID_FIELDS,
  PROFILE_BASIC_FIELDS,
  WORK_EXPERIENCES_FIELDS,
  TIMESTAMP_FIELDS,
} from "graphql/fragments";

const GET_NETWORK_PROFILES = gql`
  ${RESULT_FILTER_METADATA}
  ${DISCIPLINE_FIELDS}
  ${SKILLS_FIELDS}
  ${LOCATION_FIELDS}
  ${WORK_EXPERIENCES_FIELDS}
  ${RATE_FIELDS}
  ${PROFILE_ID_FIELDS}
  ${PROFILE_BASIC_FIELDS}
  ${BADGES_FIELDS}
  ${TIMESTAMP_FIELDS}
  query networkProfiles(
    $filters: NetworkProfileFilter
    $advancedFilters: [AdvancedFilter!]
    $resultFilterMetadata: [String!]
    $sortKey: String
    $sortDirection: String
    $paginationInfo: PaginationInfo
    $includeWorkExperiences: Boolean = true
    $includePartner: Boolean = false
    $includeProfileList: Boolean = false
    $includeConfirmation: Boolean = false
    $listId: ID
  ) {
    networkProfiles(
      filters: $filters
      advancedFilters: $advancedFilters
      resultFilterMetadata: $resultFilterMetadata
      sortKey: $sortKey
      sortDirection: $sortDirection
      paginationInfo: $paginationInfo
    ) {
      networkProfiles {
        ...ProfileIdFields
        ...BadgesFields
        ...ProfileBasicFields
        ...DisciplineFields
        ...SkillsFields
        ...LocationFields
        ...RateFields
        ...WorkExperiencesFields @include(if: $includeWorkExperiences)
        ...TimestampFields
        completedInterviewsCount
        openToEmployment
        canShowInterviews
        sellingPriceEstimate
        flaggedCommentsCount
        assignedTo {
          name
        }
        assignedSellingRate {
          amount
          currency
          frequency
          symbol
        }
        user @include(if: $includeConfirmation) {
          id
          confirmedAt
          confirmationLink
        }
        profileList(listId: $listId) @include(if: $includeProfileList) {
          id
          negotiatedRate
          negotiatedRateCurrency
          note
        }
        partner @include(if: $includePartner) {
          id
        }
      }
      resultFilterMetadata {
        ...ResultFilterMetadata
      }
      pageInfo {
        totalCount
        currentPage
        currentOffset
        hasNextPage
        hasPreviousPage
        perPage
      }
    }
  }
`;

export { GET_NETWORK_PROFILES };
